<div class="gpd-full-page project-params-page">
  <app-section-area-types></app-section-area-types>
  <app-section-remuneration-tags></app-section-remuneration-tags>
</div>